import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { emailValidation } from '@adornis/users/db/validators.js';
import { validate } from '@adornis/validation/decorators.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

/**
 * @entity ContactRequest
 */
@Entity()
export class ContactRequest extends MongoEntity {
  public static override _class = 'ContactRequest';
  public static override _collectionName = 'contact-requests';

  constructor(doc: PartialEntityData<ContactRequest>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(type => ID)
  public tokenID: Maybe<string>;

  @validate(({ value, key, target }) => {
    emailValidation({ value, key, target });
    if (!value && !target.tel) {
      throw new ValidationError('Bitte geben Sie eine E-Mail-Adresse oder eine Telefonnummer an.');
    }
  })
  @Field(type => String)
  public email: Maybe<string>;

  @validate(({ value, key, target }) => {
    if (!value && !target.email) {
      throw new ValidationError('Bitte geben Sie eine Telefonnummer oder eine E-Mail-Adresse an.');
    }
  })
  @Field(type => String)
  public tel: Maybe<string>;
}
